import { Directive, HostListener } from '@angular/core';

@Directive({
	standalone: true,
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[stopKeyPropagation]',
})
export class StopKeyPropagationDirective {
	@HostListener('keydown', ['$event'])
	onKeyodwn(event: KeyboardEvent) {
		event.stopPropagation();
	}
}
